import * as INSTITUTIONS from '../../actionTypes/Institutions/Institutions';

const initialInstitutionsState = {
  institutions: [],
};

export default function institutionsReducer(state = initialInstitutionsState, action) {
  switch (action.type) {
    case INSTITUTIONS.INSTITUTIONS_LIST:
      return { ...state, institutions: action.institutions };
    default:
      return state;
  }
}
